import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { lightTheme } from '../../themeSwitcher';

import DashboardSummary from '../dashboardSummary/DashboardSummary.jsx';
import Sidebar from '../dashboardNavigation/Sidebar';
import Header from '../Navigation/Header';

import ProductList from './productList/ProductList';
import ExhibitorProductList from './exhibitor_Product/ExhibitorProductList';
import EditProductPage from './exhibitor_Product/EditProductPage/EditProductPage';
import AddProduct from './exhibitor_Product/AddProduct';
import AddKeyExhibitors from './exhibitor_Product/AddKeyExhibitors';
import AddSeo from './exhibitor_Product/AddSeo';
import DataCount from '../dataCount/DataCount';
import DownloadSampleUserList from './download_sample_user/DownloadSampleUserList';
import RegisterUserList from './superAdminPages/registerUserlist/RegisterUserList';
import UploadedProductList from './dataAdmin/Uploaded_product_list';
import DataStore from './dataAdmin/DataStore/DataStore';
import DataRows from './dataAdmin/DataStore/DataRows';
import AddEventUserList from './download_sample_user/AddEventUserList';
import Userlogindatatable from './adminuser/Userlogindatatable';
import Categories from './../categories/Categories';
import ContactUserList from './contactUserList/ContactUserList';
import RedirectionPage from '../SeoTools/Redirection/RedirectionPage';
import GoogleMerchentPage from './Connected Apps/GoogleMerchentConnection/GoogleMerchentPage';
import Subscriptions from './Subscriptions Models/Subscriptions';
import JobTable from './job/JobTable';
import Freedatasets from '../Navigation/freedataset/freedatasets'; // Route path: /Navigation/freedatasets
//import UserDatasetTable from './userdataset/Userdataset.jsx'; // Route path: /dashboard/userdataset
import Usersdataset from './usersdataset/Usersdataset.jsx'; // Route path: /dashboard/userdataset
import Exhibitorslist from './exhibitorslist/Exhibitorslist';
import Orderslist from './order-list/Orderslist.jsx';
import Bookmark from './bookmark/Bookmark';
import Key from './apikey/key';
import Utmrecords from './utmrecord/utmrecord';
import RefinedLeadCreditTable from '../Navigation/Headercomponents/RefinedLeadCreditTable';
import PlanPurchasesPage from './planPurchases/PlanPurchasesPage';
import CustomersPage from './customers/CustomersPage';
import CustomerDetailPage from './customers/CustomerDetailPage';


import './Dashboard.css'; // Custom dashboard styles
import { AllBatches } from './dataAdmin/DataStore/allbatches.jsx';
import Sitemap from '../Sitemap/sitemap.js';


const Dashboard = () => {
  const stats = {
    totalUsers: 1200,
    activeUsers: 950,
    totalOrders: 300,
    pendingOrders: 75,
    revenue: 120000,
  };

  const themeMode = 'light';
  //okay
  return (
    <ThemeProvider theme={lightTheme}>
      <div className="dashboard">
        {/* Top Header */}
        <Header themeMode={themeMode} />

        <div className="dashboard-container">
          {/* Left Sidebar */}
          <Sidebar />

          {/* Right Main Content */}
          <div className="dashboard-content">
            <Routes>
              <Route path="/" element={<DashboardSummary stats={stats} />} />
              <Route path="/freedatasets" element={<Freedatasets />} />
              <Route path="/productlist" element={<ProductList />} />
              <Route path="/exhibitor-productlist" element={<ExhibitorProductList />} />
              <Route path="/edit-product/:id" element={<EditProductPage />} />
              <Route path="/add-product" element={<AddProduct />} />
              <Route path="/addkeyexhibitor/:id" element={<AddKeyExhibitors />} />
              <Route path="/addseo/:id" element={<AddSeo />} />
              <Route path="/sanctionsdatabase-datacount" element={<DataCount />} />
              <Route path="/download-sample-user" element={<DownloadSampleUserList />} />
              <Route path="/register-user-list" element={<RegisterUserList />} />
              <Route path="/upload-data" element={<UploadedProductList />} />
              <Route path="/data-store" element={<DataStore />} />
              <Route path="/data-rows/:woocommerceId/:recordId" element={<DataRows />} />
              <Route path="/add-event-user-list" element={<AddEventUserList />} />
              <Route path="/admin-user" element={<Userlogindatatable />} />
              <Route path="/categories" element={<Categories />} />
              <Route path="/contact-user-list" element={<ContactUserList />} />
              <Route path="/redirection" element={<RedirectionPage />} />
              <Route path="/sitemap" element={<Sitemap />} />
              <Route path="/connected-apps/google-merchent" element={<GoogleMerchentPage />} />
              <Route path="/subscriptions-models" element={<Subscriptions />} />
              <Route path="/job" element={<JobTable />} />
              {/* <Route path="/userdataset" element={<UserDatasetTable />} />  */}
              <Route path="/usersdataset" element={<Usersdataset />} />
              <Route path="/exhibitorslist" element={<Exhibitorslist />} />
              <Route path='/order-list' element={<Orderslist />} />
              <Route path='/bookmark' element={<Bookmark />} />
              <Route path='/apikey' element={<Key />} />
              <Route path="/Allbatches" element={<AllBatches />} />
              <Route path="/utmrecord" element={<Utmrecords />} />
              <Route path="/builder-analytics" element={<RefinedLeadCreditTable />} />
              <Route path="/plan-purchases" element={<PlanPurchasesPage />} />
              <Route path="/customers" element={<CustomersPage />} />
              <Route path="/customers/:id" element={<CustomerDetailPage />} />
              {/* Add more routes here as needed */}
            </Routes>
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
};

export default Dashboard;
